import React from 'react';
import classNames from 'classnames';

export function ModalBackground(props) {
    const classes = classNames({ show: props.display });
    return <div id="darkBkd" className={classes} />;
}
